import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import styled from 'styled-components';

export const StyledPage = styled.div`
  ${({ theme }) => {
    return `
    display: flex;
    justify-content: center;
    background-color: ${theme.background.base};
    width: 100%;    

    flex: 1 1 auto;

    padding: 40px 64px 124px;

    @media screen and (max-width: ${cxTheme.breakpoints.desktop}px) {
      padding: 40px 0 124px;
    }
  `;
  }}
`;

export const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  max-width: 2160px;
`;
